import React from 'react';

import { Container, Cover } from './styles';
import {
  IDisableChildren,
  IDisableChildrenContainer,
  IDisableChildrenCover,
} from './types';

/**
  DisableChildren:

  Apply an opacity overlay to wrapped components
  Applying opacity to a sibling that grows to the height of the
  container - means you can allow individual children to poke
  through the disabled opacity overlay - by setting their z-index higher
  and their pointer-events to auto.

  Avoids using a conditional render of the cover - which prevents memoisation
  if required.

  @param props.disabled - Disables children
  @param props.height - pass null to override the default of 100%

*/
const DisableChildren = ({
  children,
  containerPosition,
  coverHeight,
  disabled = false,
  height,
  renderContainer = true,
  zIndex = 1,
  ...rest
}: IDisableChildren & IDisableChildrenCover & IDisableChildrenContainer) => {
  if (!renderContainer && !disabled) {
    // eslint-disable-next-line
    return <>{children}</>;
  }
  return (
    <Container
      disabled={disabled}
      height={height}
      containerPosition={containerPosition}
    >
      <Cover
        disabled={disabled}
        zIndex={zIndex}
        {...rest}
        height={coverHeight}
      />
      {children}
    </Container>
  );
};

export default DisableChildren;
